import React from 'react';
import styles from './ProductMetadata.module.scss';
import ProductHeader from '../ProductHeader/ProductHeader';
import ProductMetadataTable from './ProductMetadataTable';
import { IAlbum } from '@/data/models/album';
import { ProjectDto } from '@/data/models/projectsService';
import { IValidationResults } from '@/data/models/validation';
import { ICurrentProductMetadataChangesGroup } from '@/types/product-current-changes-types';
import { IChangeRequest } from '@/data/models/changeRequest';

export type ProductMetadataProps = {
  album: IAlbum;
  project?: ProjectDto;
  readonly: boolean;
  errors: IValidationResults[];
  errorFlag: boolean;
  onToggleLabelInfoModal: () => void;
  onToggleParentLabelInfoModal: () => void;
  onEditProductClicked: () => void;
  DetailsTableComponent?: React.ComponentType<any>;
  changeRequest?: IChangeRequest;
  currentChanges?: ICurrentProductMetadataChangesGroup;
};

export default function ProductMetadata({
  album,
  project,
  readonly,
  errors,
  errorFlag,
  onToggleLabelInfoModal,
  onToggleParentLabelInfoModal,
  onEditProductClicked,
  DetailsTableComponent = ProductMetadataTable,
  currentChanges,
  changeRequest,
}: ProductMetadataProps) {
  return (
    <div className={styles['product-details']}>
      <ProductHeader
        album={album}
        readonly={readonly}
        onEditProductClicked={onEditProductClicked}
        changeRequestCounter={currentChanges?.changesCounter}
      />
      <DetailsTableComponent
        errors={errors}
        errorFlag={errorFlag}
        album={album}
        project={project}
        onToggleLabelInfoModal={onToggleLabelInfoModal}
        onToggleParentLabelInfoModal={onToggleParentLabelInfoModal}
        changeRequest={changeRequest}
      />
    </div>
  );
}
